module.exports = __webpack_public_path__ + "static/media/077-no money.cbef3c9b.svg";